import setTransition from './setTransition.js';
import transitionStart from './transitionStart.js';
import transitionEnd from './transitionEnd.js';

export default {
  setTransition,
  transitionStart,
  transitionEnd,
};
